import { render, staticRenderFns } from "./vector-chart.vue?vue&type=template&id=2ebe4412&"
import script from "./vector-chart.ts?vue&type=script&lang=ts&"
export * from "./vector-chart.ts?vue&type=script&lang=ts&"
import style0 from "./vector-chart.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports